import { Guide, GuideActionType, SET_GUIDE } from './types';

export const setGuide = (guide: Guide | null): GuideActionType => {
	return {
		type: SET_GUIDE,
		payload: guide,
	};
};
